module.exports = __webpack_public_path__ + "static/media/img1.4f2557b7.jpg";